//
//
//
//
//
//
//
//
//
//
//

import Header from '../components/layout/Header.vue'
import HeaderLasa from '../components/layout/HeaderLasa.vue'
import Courier from '~/components/Courier'
import portal from '~/net/portal'

export default {
  middleware: 'appData',
  components: {
      Courier,
      Header,
      HeaderLasa
  },
  head() {
      return {
          title: '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台',
          meta: [
              {
                  hid: 'keywords',
                  name: 'keywords',
                  content: '专利转让,技术转让,专利交易,知识产权,知识产权申请,江苏省技术产权交易市场'
              },
              {
                  hid: 'description',
                  name: 'description',
                  content: '江苏省技术产权交易市场平台，专注专利转让、技术转让、专利交易、知识产权、知识产权申请，包括发明技术成果、实用新型专利、知识产权服务、电子信息、生物与新医药、航空航天、新材料、高技术服务、新能源与节能资源与环境、先进制造与自动化等服务。'
              },
              { href: 'https://www.jstec.com.cn/', rel: 'canonical' }
          ]
      }
  },
  data() {
      return {
          reSizeTimer: null,
          navigationType: '',
          headerType: 'Header'
      }
  },
  mounted() {
      // this.navigationType = localStorage.getItem('navigationType')
      // if (!this.navigationType) {
      //     this.headerType = 'Header'
      //     document.title = '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台'
      // } else {
      //     this.headerType = 'HeaderLasa'
      //     document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
      // }
      this.resizeScreen()
      window.onresize = () => {
          if (this.reSizeTimer) {
              clearInterval(this.reSizeTimer)
          }
          this.reSizeTimer = setTimeout(() => {
              this.resizeScreen()
          }, 400)
      }
      // this.queryHis()
      // this.$bus.$on('changeBar', this.changeBar)
  },
  methods: {
      resizeScreen() {
          this.$store.dispatch('ResizeScreen', {
              width: document.documentElement.clientWidth,
              height: document.documentElement.clientHeight
          })
      },
      changeBar() {
          // this.navigationType = 'lasa'
          // localStorage.setItem('navigationType', 'lasa')
          // document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
      },
      async queryHis() {
          // const strCookie = document.cookie
          // const cookies = strCookie.split(' ')
          // let touristId = ''
          // cookies.map(str => {
          //     if (str.includes('NW_TOURIST_ID')) {
          //         const tempArr = str.split('=')
          //         touristId = tempArr[1]
          //         if (touristId.indexOf(';') > 0) {
          //             touristId = touristId.substring(0, touristId.length - 1)
          //         }
          //         localStorage.setItem('TOURIST_ID', touristId)
          //     }
          // })
          // const { code, data } = await portal.selectHomePageActivityId({
          //     body: {
          //         touristId
          //     }
          // })
          // if (code == '0000') {
          //     if (data == '202410602943614795') {
          //         // 切换拉萨导航栏
          //         this.navigationType = 'lasa'
          //         localStorage.setItem('navigationType', 'lasa')
          //         this.headerType = 'HeaderLasa'
          //         this.footerType = 'FooterLasa'
          //         document.title = '拉萨市技术产权交易网-专利技术转让-专利交易发布-知识产权申请平台'
          //     } else {
          //         console.log('返回省平台')
          //         this.navigationType = ''
          //         localStorage.setItem('navigationType', '')
          //         this.headerType = 'Header'
          //         this.footerType = 'Footer'
          //         document.title = '江苏省技术产权交易市场-专利技术转让-专利交易发布-知识产权申请平台'
          //     }
          // }
      }
  }
}
